import 'isomorphic-fetch';
import cookie from 'cookie';
import queryString from 'query-string';
import config from 'config';

const urlCreator =
  typeof window !== 'undefined' && (window.URL || window.webkitURL);

function makeRequestEndpoint(requestRoot, endpoint, queryParams) {
  const protocol = config.apiProtocol ? `${config.apiProtocol}://` : '//';
  const hostname = config.apiHost || window.location.hostname;
  const path = (requestRoot || config.apiRoot || '') + (endpoint || '');
  const query = queryParams ? `?${queryString.stringify(queryParams)}` : '';

  // INFO: ТУТ добавил
  if (String(endpoint).includes('.json')) {
    return path + query;
  }

  return protocol + hostname + path + query;
}

function makeRequestOptions(method, contentType, data) {
  let token;
  let csrfToken;

  if (typeof window !== 'undefined') {
    token = window.localStorage.getItem('auth_token');
    csrfToken = cookie.parse(document.cookie).csrftoken || null;
  }

  method = method || 'GET';
  contentType = contentType || 'json';

  const requestOptions = {
    method,
    credentials: 'same-origin',
    headers: {
      Accept: 'application/json'
    }
  };

  if (csrfToken) {
    requestOptions.headers['X-CSRFToken'] = csrfToken;
  }

  if (data && contentType === 'json') {
    requestOptions.headers['Content-Type'] = 'application/json';
    requestOptions.body = JSON.stringify(data);
  }

  if (data && contentType === 'form-data') {
    requestOptions.body = new FormData();
    data = !Array.isArray(data) ? [data] : data;
    data.forEach((el) => {
      if (el.filename) {
        requestOptions.body.append(el.name, el.value, el.filename);
      } else {
        requestOptions.body.append(el.name, el.value);
      }
    });
  }

  if (token) {
    requestOptions.headers.authorization = `JWT ${token}`;
  }

  return requestOptions;
}

function makeRequest(request) {
  const {
    method,
    requestRoot,
    endpoint,
    queryParams,
    contentType,
    data,
    retry
  } = request;

  const requestEndpoint = makeRequestEndpoint(
    requestRoot,
    endpoint,
    queryParams
  );
  const requestOptions = makeRequestOptions(method, contentType, data);

  if (!requestEndpoint || !requestOptions) {
    throw Error("Can't send API request");
  }

  return fetch(requestEndpoint, requestOptions).then((response) => {
    const { status, ok, headers } = response;
    const result = { status };

    if (ok && (requestOptions.method === 'DELETE' || status === 204)) {
      return result;
    }

    if (!ok && retry) {
      if (typeof retry === 'number') {
        if (!request.retryCounter) {
          request.retryCounter = 1;
        } else {
          request.retryCounter++;
        }

        if (request.retryCounter <= retry) {
          return makeRequest(request);
        }
      } else {
        return makeRequest(request);
      }
    }

    let promise;

    if (
      headers.get('Content-Type') &&
      headers.get('Content-Type').indexOf('application/json') !== -1
    ) {
      promise = response.json().then((json) => {
        if (!ok) {
          result.error = json;
        } else {
          result.response = json;
        }
      });
    } else if (
      headers.get('Content-Type') &&
      headers.get('Content-Type').indexOf('image/png') !== -1
    ) {
      promise = response.blob().then((data) => {
        if (!ok) {
          if (status === 413) {
            result.error = {
              nonFieldErrors: 'Размер картинки слишком большой'
            };
          } else {
            result.error = { nonFieldErrors: 'Произошла неизвестная ошибка.' };
          }
        } else {
          result.response = urlCreator && urlCreator.createObjectURL(data);
          result.error = { nonFieldErrors: 'Произошла неизвестная ошибка.' };
        }
      });
    } else {
      promise = response.text().then((text) => {
        if (!ok) {
          if (status === 413) {
            result.error = {
              nonFieldErrors: 'Размер картинки слишком большой'
            };
          } else {
            result.error = { nonFieldErrors: 'Произошла неизвестная ошибка.' };
          }
        } else {
          result.error = { nonFieldErrors: 'Произошла неизвестная ошибка.' };
        }
      });
    }

    return promise.then(() => {
      if (!ok) {
        if (!result.error) {
          result.error = {
            nonFieldErrors: 'Произошла ошибка. Попробуйте обновить страницу.'
          };
        }

        throw result;
      } else {
        if (!result.response) {
          result.response = null;
        }

        return result;
      }
    });
  });
}

function actionWith(action, status, payload) {
  return Object.assign({}, action, { status: status }, payload);
}

export default function createApiMiddleware() {
  return (store) => (dispatch) => (action) => {
    if (!action) {
      return;
    }

    if (!action.request && !action.requests) {
      return dispatch(action);
    }

    dispatch(actionWith(action, 'SEND'));

    if (action.request) {
      return makeRequest(action.request).then(
        (result) => {
          return dispatch(
            actionWith(action, 'SUCCESS', {
              request: Object.assign({}, action.request, {
                response: result.response,
                statusCode: result.status
              })
            })
          );
        },

        (result) => {
          return dispatch(
            actionWith(action, 'FAIL', {
              request: Object.assign({}, action.request, {
                error: result.error,
                statusCode: result.status
              })
            })
          );
        }
      );
    }

    if (action.requests) {
      return Promise.all(
        action.requests.map((request) => makeRequest(request))
      ).then(
        (results) => {
          return dispatch(
            actionWith(action, 'SUCCESS', {
              requests: action.requests.map((request, key) => {
                const result = results[key];

                return Object.assign({}, request, {
                  response: result ? result.response : null,
                  statusCode: result ? result.status : null
                });
              })
            })
          );
        },

        (result) => {
          return dispatch(
            actionWith(action, 'FAIL', {
              error: result.error,
              statusCode: result.status
            })
          );
        }
      );
    }
  };
}



// WEBPACK FOOTER //
// ./src/redux/middleware/api.js